__turbopack_context__.v({
  "agentPhoto": "JN1lsG_agentPhoto",
  "chip": "JN1lsG_chip",
  "container": "JN1lsG_container",
});
